import {useSelector} from 'react-redux'
import {RootState} from '../../../redux/store'
import {toAbsoluteUrl} from '../../../template/_metronic/helpers'
import {HeaderUserMenu} from './HeaderUserMenu'

const Navbar = () => {
  const currentUser = useSelector((state: RootState) => state.authSlice.user)
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className='app-navbar-item ms-1 ms-lg-3'>
        <div
          className='cursor-pointer symbol symbol-circle symbol-50px'
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl('/media/soyfri-media/profile-image.png')} alt='' />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Navbar}
